<script setup>
import { ref } from 'vue';


const emit = defineEmits(['reload']);
const modalRef = ref(null);

// 「再読み込み」押下時：再取得を依頼してからモーダルを閉じる
const onClickReload = () => {
  emit('reload');

  bootstrap.Modal.getInstance(modalRef.value)?.hide();
};
</script>

<template>
  <div ref="modalRef" class="modal com_modal2 fade" id="cartReloadRequiredModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">カート内容が更新されています</h3>
          <p class="com_fs14 com_center1 com_mgb0">再読み込みしてください</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn2 wd1" @click="onClickReload">再読み込み</button>
        </div>
      </div>
    </div>
  </div>
</template>
